<!-- <ng-template [ngIf]="autoshow">
  <div *ngIf="!isCombo && material" class="btn-group" dropdown #dropdown="bs-dropdown" style="width:100%;"
    id="{{('autocomplete_' + common.indexNameAutocomplete)}}" [autoClose]="true" [isOpen]="status.isopen"
    (isOpenChange)="change($event)" (blur)="toggleDropdown" container="{{container ? 'body' : ''}}" [dropup]="dropup">
    <label (click)="showAutoCompleteMaterial()"
      style="left: 2px;color: rgba(0, 0, 0, 0.5);font-size: 10px;font-weight: 400;" *ngIf="isFocus || search">{{ label
      }}</label>
    <label (click)="showAutoCompleteMaterial()"
      style="left: 2px;color: rgba(0, 0, 0, 0.6);font-size: 15px;font-weight: 400; top: 13px;"
      *ngIf="!(isFocus || search)">{{ label }}</label>
    <form autocomplete="off">
      <input #autocompletematerial type="text" class="input {{id}}" [(ngModel)]="search"
        (blur)="isFocus = false; blurfct()" id="{{changeIDAutoComplete ? idElement : 'autocomplete'}}"
        [placeholder]="placeholder" name="{{'autocomplete_' + common.indexNameAutocomplete}}" [disabled]="active"
        (focus)="focus(dropdown, $event);" (ngModelChange)="searchelement($event);"
        [ngClass]="{'input-focus':status.isopen, 'noValue': !isFocus && !search}" (keyup)="defaultFocus($event)"
        (mouseover)="getPosition($event)" (keydown.enter)="valideChoice($event)" autocomplete="garbage" autofill="off"
        aria-autocomplete="none" maskPass [visible]="activeVisibleChamp ? visibleChamp : true"
        style="border: none; height: 55px!important;" maxlength="{{ maxlength }}" />
    </form>

    <ul *dropdownMenu
      class="dropdown-menu {{dropdownclass}}  {{container ? 'minWidthDropDownContainer' : ''}} {{ positionDropdown !== '' ? ('position' + positionDropdown) : '' }}"
      id="dropdowauto" role="menu">
      <li role="menuitem" *ngFor="let item of results; let i = index;" class="items" (keyup)="changeFocus($event, i)"
        tabindex="{{i}}" [ngClass]="{'selected': (selected && (item.id === selected.id)) || (results.length === 1)}"
        (keyup.enter)="selectItem(item)" (click)="selectItem(item)">
        <a class="dropdown-item" *ngIf="!highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + 
        (item.prenomDetenteur ? ' ' + item.prenomDetenteur : '') +
        (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || ''))) |highlight:search">
        </a>
        <a class="dropdown-item" *ngIf="highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + 
        (item.prenomDetenteur ? ' ' + item.prenomDetenteur : '') +
        (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || '')))">
        </a>
      </li>
      <li role="menuitem" *ngIf="!results.length"><a class="dropdown-item"> {{ hasRequestLoad || encoursDechargement ?
          'Chargement ...' : 'Pas de
          correspondance' }} </a></li>
    </ul>
  </div>

  <div *ngIf="!isCombo && !material" class="btn-group" dropdown #dropdown="bs-dropdown" style="width:100%;"
    [autoClose]="true" [isOpen]="status.isopen" (isOpenChange)="change($event)" (blur)="toggleDropdown"
    container="{{container ? 'body' : ''}}" [dropup]="dropup">
    <label *ngIf="isFocus || search">{{ label }}</label>
    <form autocomplete="off">
      <input type="text" class="input {{id}}" [(ngModel)]="search" (blur)="isFocus = false; blurfct()"
        id="{{changeIDAutoComplete ? idElement : 'autocomplete'}}" [placeholder]="placeholder" name="search"
        [disabled]="active" (focus)="focus(dropdown, $event);" (ngModelChange)="searchelement($event);"
        [ngClass]="{'input-focus':status.isopen, 'noValue': !isFocus && !search}" (keyup)="defaultFocus($event)"
        (mouseover)="getPosition($event)" (keydown.enter)="valideChoice($event)" autocomplete="garbage"
        aria-autocomplete="none" autofill="off" maskPass [visible]="activeVisibleChamp ? visibleChamp : true"
        maxlength="{{ maxlength }}" />
    </form>

    <ul *dropdownMenu
      class="dropdown-menu {{dropdownclass}}  {{container ? 'minWidthDropDownContainer': '' }}  {{!container && dropup ? 'if_not_container':'' }} {{ positionDropdown !== '' ? ('position' + positionDropdown) : '' }}"
      id="dropdowauto" role="menu">
      <li role="menuitem" *ngFor="let item of results; let i = index;" class="items" (keyup)="changeFocus($event, i)"
        tabindex="{{i}}" [ngClass]="{'selected': (selected && (item.id === selected.id)) || (results.length === 1)}"
        (keyup.enter)="selectItem(item)" (click)="selectItem(item)">
        <a class="dropdown-item" *ngIf="!highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + 
        (item.prenomDetenteur ? ' ' + item.prenomDetenteur : '') +
        (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || ''))) |highlight:search">
        </a>
        <a class="dropdown-item" *ngIf="highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + 
        (item.prenomDetenteur ? ' ' + item.prenomDetenteur : '') +
        (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || '')))">
        </a>
      </li>
      <li role="menuitem" *ngIf="!results.length"><a class="dropdown-item"> {{ hasRequestLoad || encoursDechargement ?
          'Chargement ...' : 'Pas de
          correspondance' }} </a></li>
    </ul>
  </div>

  <div class="btn-group dropdown" *ngIf="isCombo" dropdown #dropdown="bs-dropdown" style="width:100%;" [dropup]="dropup"
    container="{{container ? 'body' : ''}}" [isDisabled]="isDisabled">
    <label *ngIf="isFocus || search">{{ label }}</label>
    <button class="combo text-left {{id}}" dropdownToggle (click)="setFocusSelect($event, dropdown)" [disabled]="active"
      [ngClass]="{'disabledbutton': active, 'noValue': !isFocus && !search}" (mouseover)="getPosition($event)">
      <span *ngIf="!isFixedHTML">{{ (search && search.length) ? search : placeholder}}</span>
      <div *ngIf="isFixedHTML" [innerHTML]="htmlCode"></div>
      <img *ngIf="rechercheIcone" alt="search" class="pull-right ng-star-inserted" src="assets/images/icons/search.svg"
        id="recherche_pro_forma_btnsearch" style="
    position: relative;
    top: -3px;
">
    </button>
    <ul *dropdownMenu
      class="dropdown-menu {{dropdownclass}} {{container ? 'minWidthDropDownContainer' : ''}} {{!container && dropup ? 'if_not_container':'' }}"
      id="dropdowauto" role="menu" aria-labelledby="dropdownMenuButton">
      <li role="menuitem" *ngFor="let item of results; let i = index;" class="items" (keyup)="changeFocus($event, i)"
        tabindex="{{i}}" [ngClass]="{'selected': (selected && (item.id === selected.id)) || (results.length === 1)}"
        (keyup.enter)="selectItem(item); dropdown.hide();" (click)="selectItem(item)">
        <a class="dropdown-item" *ngIf="!highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || ''))) |highlight:search">
        </a>
        <a class="dropdown-item" *ngIf="highlight"
          [innerHTML]="(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
        (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || '')))">
        </a>
      </li>
      <li role="menuitem" *ngIf="!results.length"><a class="dropdown-item"> {{ hasRequestLoad || encoursDechargement ?
          'Chargement ...' : 'Pas de
          correspondance' }} </a></li>
    </ul>
  </div>
</ng-template>

<ng-template [ngIf]="!autoshow"> -->
  <app-autocomplete-material [placeholder]="placeholder" [dataSource]="dataSource" [results]="results" [label]="label"
    [defaultsearch]="defaultsearch" [id]="id" [notOblig]="notOblig" [active]="active" [minlength]="minlength"
    [maxlength]="maxlength" [autoshow]="autoshow" [autohide]="autohide" [selectvalue]="selectvalue"
    [disablefocus]="disablefocus" [isCombo]="isCombo" [container]="container" [model]="model" [items]="items"
    [defaultselected]="defaultselected" [dropdownclass]="dropdownclass" [highlight]="highlight"
    [showonclick]="showonclick" [showonFoscus]="showonFoscus" [showResultKeyenter]="showResultKeyenter"
    [deleteSelectedValue]="deleteSelectedValue" [isFixedHTML]="isFixedHTML" [rechercheIcone]="rechercheIcone"
    [htmlCode]="htmlCode" [notShowOnInit]="notShowOnInit" [forceSelection]="forceSelection"
    [activeDropUp]="activeDropUp" [activeVisibleChamp]="activeVisibleChamp" [visibleChamp]="visibleChamp"
    [notLoading]="notLoading" [isDisabled]="isDisabled" [addTimerBlur]="addTimerBlur" [deleteLibelle]="deleteLibelle"
    [encoursDechargement]="encoursDechargement" [changeIDAutoComplete]="changeIDAutoComplete" [material]="material"
    [positionDropdown]="positionDropdown" [ActiveFocusCombo]="ActiveFocusCombo" [actualise]="actualise"
    [autoActiveFirstOption]="false" [isClearResult]="isClearResult" [activeDelaiRecherche]="activeDelaiRecherche" 
    [nePasCompterEspace]="nePasCompterEspace"
    (searchfunction)="searchfunctionEvent($event)" (selectfunction)="selectfunctionEvent($event)"
    (keyenterfunction)="keyenterfunctionEvent($event)" (focusfunction)="focusfunctionEvent($event)"
    (blurfunction)="blurfunctionEvent($event)" (clearfunction)="clearfunctionEvent($event)"
    (keyUp)="keyUpEvent($event)">
  </app-autocomplete-material>
<!-- </ng-template> -->